import { handleKeyDownInput as handleKeyDownInputImpl } from '#pplx/frontend/composer-sdk/internal/keyboard.js';
export const handleKeyDownInput = handleKeyDownInputImpl;
//# sourceMappingURL=keyboard.js.map